import { render, staticRenderFns } from "./StaticGallery.vue?vue&type=template&id=431c3270"
import script from "./StaticGallery.vue?vue&type=script&lang=js"
export * from "./StaticGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports